export default "__VITE_ASSET__CeFZse6w__"